import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

function CustomLoader() {
  return (
    <Box
      component="div"
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <CircularProgress sx={{ color: "#9ba4b4" }} />
    </Box>
  );
}

export default CustomLoader;
